import { Application } from "@hotwired/stimulus"

// Rails 8 compatible Stimulus application
const application = Application.start()

// Configure Stimulus for Rails 8
application.debug = process.env.NODE_ENV === "development"
application.lazyLoad = true // Lazy load controllers in Rails 8 for better performance

// Add dispatch method if it doesn't exist (Rails 8 compatibility)
if (!application.dispatch) {
  application.dispatch = function(eventName, { target = document, detail = {}, bubbles = true, cancelable = true } = {}) {
    const event = new CustomEvent(eventName, { detail, bubbles, cancelable })
    target.dispatchEvent(event)
    return event
  }
}

// Make Stimulus available globally for debugging
window.Stimulus = application

export { application }